import CreateUserModal from "./create-user-modal.component";

export default CreateUserModal;
